export const CREATE_PLAN = 'CREATE_PLAN';
export const DELETE_PLAN = 'DELETE_PLAN';
export const SAVE_PLAN = 'SAVE_PLAN';
export const UPDATE_PLAN = 'UPDATE_PLAN';
export const UPDATE_PLANS_LIST = 'UPDATE_PLANS_LIST';
export const SHARE_PLAN = 'SHARE_PLAN';
export const SEND_FEEDBACK = 'SEND_FEEDBACK';
